export interface IMediaSupport {
  canPlay: (type: string) => boolean;
}

export const createMediaSupport = (): IMediaSupport => {
  const cache = new Map<string, boolean>();

  return {
    canPlay: (type: string): boolean => {
      const elementType = type.startsWith("audio/") ? "audio" : type.startsWith("video/") ? "video" : null;

      if (elementType === null || typeof document === "undefined") {
        return false;
      }

      const cached = cache.get(type);
      if (cached !== undefined) {
        return cached;
      }

      const supported = document.createElement(elementType).canPlayType(type) !== "";
      cache.set(type, supported);
      return supported;
    },
  };
};

export const mediaSupport = createMediaSupport();
